module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-kia-24.5e646e1d.jpg";